var map = {
	"./01_get_Query_Invited_Users.json": "Bd4q",
	"./02_get_Daily_Commission_Query.json": "Czkf",
	"./03_get_Query_agent_user_nformation.json": "N9hH",
	"./04_get_Query_the_deposit_details.json": "ZKxt",
	"./05_get_Query_API_transaction_commission.json": "mYC+",
	"./06_get_Query_partner_information.json": "sHlI",
	"./07_get_referral_code_commission.json": "OWE/",
	"./08_get_Query_agent_superior_check.json": "aK5B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bz8+";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/agent/api/agent \.json$
// module id = bz8+
// module chunks = 3